import { render, staticRenderFns } from "./charts-panel.vue?vue&type=template&id=c8aeb55a&"
var script = {}
import style0 from "../../../assets/styles/panels/_ChartsPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports